

import { InjectionToken } from '@angular/core';

import { MenuService } from './menu.service';

export const MwcIsMenuInsideDropDownToken = new InjectionToken<boolean>('MwcIsInDropDownMenuToken');
export const MwcMenuServiceLocalToken = new InjectionToken<MenuService>('MwcMenuServiceLocalToken');
